import React, { useRef } from "react";
import Map, { NavigationControl } from "react-map-gl/mapbox";
import "mapbox-gl/dist/mapbox-gl.css";
import { MAPBOX_ACCESS_TOKEN, MAPBOX_STYLES } from "config/mapConfig";

export default function MapboxBaseMap({
  children,
  mapStyle,
  zoomPosition = "bottom-right",
  className = "",
  visibleZoom = true,
  zoomLevel = 11,
  center = [9.1824, 45.4685], // Note: Mapbox uses [longitude, latitude] order
  scrollWheelZoom = true,
  mapRef,
  doubleClickZoom = true,
  onClick = () => {},
  onMouseMove = () => {},
  interactiveLayerIds = [],
}) {
  // Generate a unique key for the map
  const mapKey = `${center[1]}-${center[0]}-${zoomLevel}`;

  return (
    <Map
      key={mapKey}
      ref={mapRef}
      mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
      initialViewState={{
        longitude: center[0],
        latitude: center[1],
        zoom: zoomLevel,
      }}
      style={{ height: "100vh", width: "100%", ...mapStyle }}
      mapStyle={MAPBOX_STYLES.STREETS}
      scrollZoom={scrollWheelZoom}
      className={className}
      attributionControl={false}
      doubleClickZoom={doubleClickZoom}
      interactiveLayerIds={interactiveLayerIds}
      onClick={onClick}
      onMouseMove={onMouseMove}
    >
      {children}

      {visibleZoom && (
        <NavigationControl position={zoomPosition} showCompass={false} />
      )}
    </Map>
  );
}
